<template>
  <v-container fluid class="text-center mt-5">
    <v-row>
      <v-col cols="4">
        <v-card class="rounded-xl elevation-5">
          <v-toolbar dense dark color="secondary" elevation="2">
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading || !isWriting"
              @click="dialogs.new = true"
            >
              Agregar
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <v-btn
              small
              outlined
              :loading="loading"
              color="secondary"
              class="mx-2"
              elevation="0"
              :disabled="!isWriting"
              @click="refreshPermissions()"
            >
              Actualizar
              <v-icon right>mdi-refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headers"
              :items="items"
              :loading="loading"
              :search="search"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                itemsPerPageAllText: 'Todos',
              }"
              :items-per-page="5"
              item-key="roleID"
              class="mt-5"
              :single-select="true"
              show-select
              v-model="selectedRol"
              @input="selectRole()"
            >
              <v-progress-linear
                slot="progress"
                color="primary"
                indeterminate
              ></v-progress-linear>
              <template v-slot:item.actions="{ item }">
                <infoBtn
                  iconName="mdi-eye"
                  text="Detalle"
                  actionColor="primary"
                  :data="item"
                  :onClick="view"
                  :permission="!isReading"
                />
                <infoBtn
                  iconName="mdi-delete"
                  text="Eliminar"
                  actionColor="error"
                  :data="item"
                  :onClick="remove"
                  :permission="!isWriting"
                />
              </template>
              <template v-slot:footer.page-text="props">
                Página {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <template v-slot:no-data>
                No hay información disponible
              </template>
              <template v-slot:no-results>
                No se obtuvieron resultados
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card v-if="selectedRol.length > 0" class="rounded-xl elevation-5">
          <v-toolbar dense dark color="secondary" elevation="2">
            <v-toolbar-title
              >Permisos del rol: {{ selectedRol[0].rol }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              :disabled="loading || !isWriting"
              @click="savePermissions()"
            >
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <v-btn
              small
              outlined
              color="secondary"
              class="mx-2"
              elevation="0"
              :disabled="!isWriting"
              @click="selectRole()"
            >
              Actualizar
              <v-icon right>mdi-refresh</v-icon>
            </v-btn>
            <v-switch
              v-model="filterResources"
              :label="textFilter"
              @click="filterResourcesChange()"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchResources"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headersPermissions"
              :items="allPermissionsToShow"
              :loading="loadingResources"
              :search="searchResources"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                itemsPerPageAllText: 'Todos',
              }"
              :items-per-page="5"
              class="mt-5"
              :single-select="false"
              show-select
              item-key="permisoID"
              v-model="selectedPermissions"
              @input="selectResource()"
            >
              <v-progress-linear
                slot="progress"
                color="primary"
                indeterminate
              ></v-progress-linear>
              <template v-slot:footer.page-text="props">
                Página {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <template v-slot:no-data>
                No hay información disponible
              </template>
              <template v-slot:no-results>
                No se obtuvieron resultados
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogs.new" persistent scrollable max-width="600px">
      <v-card class="rounded-xl elevation-16">
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Nuevo permiso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn
            text
            small
            :loading="loading"
            :disabled="!isWriting"
            @click="save()"
          >
            Guardar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formNew" lazy-validation v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="mdi-account-lock"
                    v-model="forms.new.rol"
                    label="Rol"
                    :rules="[rules.required, rules.max20]"
                    :disabled="loading"
                    maxlength="20"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.detail"
      persistent
      scrollable
      max-width="600px"
    >
      <v-card class="rounded-xl elevation-16">
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Detalle rol</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn
            text
            small
            :disabled="loading || !isWriting"
            @click="update()"
          >
            Actualizar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formDetail" lazy-validation v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="mdi-account-lock"
                    v-model="forms.detail.rol"
                    label="Rol"
                    :rules="[rules.required, rules.max20]"
                    :disabled="loading"
                    maxlength="20"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.remove" persistent max-width="400">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="0">
          <v-toolbar-title>Aviso importante</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p class="mt-5 text-h6">¿Desea eliminar el rol?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            :disabled="loading"
            color="blue-grey"
            @click="cancel()"
          >
            Cancelar
          </v-btn>
          <v-btn
            small
            text
            :loading="loading"
            color="error"
            :disabled="!isRemoving"
            @click="remove()"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from '@/utils/services'
import { infoBtn } from "@/components";

export default {
  name: 'roles',
  components: { infoBtn },
  data: () => ({
    visible: false,
    loading: false,
    loadingResources: false,
    success: false,
    msgSuccess: "",
    msgError: "",
    error: false,
    codeError: "",
    search: "",
    searchResources: "",
    selectedPermissions: [],
    selectedRol: [],
    rolePermissions: [],
    singleSelect: false,
    headers: [
      { text: "Roles", align: "left", sortable: true, value: "rol" },
      { text: "Acciones", align: "right", sortable: true, value: "actions" },
    ],
    headersPermissions: [
      { text: "Permisos", align: "left", sortable: true, value: "permiso" },
    ],
    items: [],
    itemsCSV: [],
    routes: [
      {
        text: "Inicio",
        disabled: false,
        href: "Home",
        icon: "mdi-home",
        color: "secondary",
      },
      {
        text: "Seguridad",
        disabled: false,
        href: "roles",
        icon: "mdi-server-security",
        color: "secondary",
      },
      {
        text: "Roles",
        disabled: true,
        href: "roles",
        icon: "mdi-account-convert",
      },
    ],
    allPermissions: [],
    allPermissionsToShow: [],
    filterResources: false,
    textFilter: "Todos",
    forms: {
      new: {
        rol: "",
      },
      detail: {
        rol: "",
      },
    },
    rules: {
      required: (v) => !!v || "El campo es obligatorio",
      max20: (v) => (v || "").length <= 20 || "Limite de caracteres",
    },
    selected: null,
    dialogs: {
      new: false,
      detail: false,
      remove: false,
    },
  }),
  mounted() {
    if (this.isReading) {
      this.refresh();
    }
  },
  computed: {
    isReading: function() {
      return services.check(1, this.$route.path);
    },
    isWriting: function() {
      return services.check(2, this.$route.path);
    },
    isRemoving: function() {
      return services.check(3, this.$route.path);
    },
  },
  methods: {
    async selectRole() {
      if (this.selectedRol.length == 0) {
        return;
      }
      this.loadingResources = true;
      this.allPermissionsToShow = [];
      await this.getAllPermissions();
      await this.gerRolPermissions(this.selectedRol[0].roleID);
      this.selectedPermissions = [];
      this.rolePermissions.map((rp) => {
        let selected = this.allPermissions.find(
          (r) => r.permisoID == rp.permisoID
        );
        if (selected) {
          this.selectedPermissions.push(selected);
        }
      });
      if (!this.filterResources) {
        this.allPermissionsToShow = this.allPermissions;
      } else {
        this.allPermissionsToShow = [];
        this.allPermissionsToShow = this.selectedPermissions;
      }
      this.loadingResources = false;
    },
    async selectResource() {
      if (this.filterResources) {
        this.allPermissionsToShow = [];
        this.allPermissionsToShow = this.selectedPermissions;
      } else {
        this.allPermissionsToShow = this.allPermissions;
      }
    },
    async savePermissions() {
      this.loadingResources = true;
      let data = [];
      this.selectedPermissions.map((e) => {
        data.push({
          rol: this.selectedRol[0].roleID,
          permiso: e.permisoID,
        });
      });

      if(this.selectedPermissions.length == 0) {
        data.push({
          rol: this.selectedRol[0].roleID,
          permiso: null
        });
      }

      let body = {
        data: data,
      };
      services
        .ws("post", "asignar_permiso", body)
        .then((res) => {
          if (res.ok) {
            this.success = true;
            this.msgSuccess = "Permisos actualizados exitosamente";
          } else {
            this.error = true;
            this.codeError = "NO_ACTION";
          }
        })
        .finally(() => {
          this.loadingResources = false;
        });
    },
    refreshPermissions() {
      this.loading = true;
      services
        .ws("get", "roles")
        .then((res) => {
          if (res.ok) {
            this.items = res.data;
          } else {
            this.error = true;
            this.codeError = res.code;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async gerRolPermissions(roleID) {
      await services
        .ws("get", "permisos_rol", roleID, "url")
        .then((res) => {
          if (res.ok) {
            this.rolePermissions = res.data;
          } else {
            this.error = true;
            this.codeError = res.code;
          }
        })
        .finally(() => {});
    },
    async getAllPermissions() {
      await services.ws("get", "permisos")
        .then((res) => {
          if (res.ok) {
            this.allPermissions = res.data;
          } else {
            this.error = true;
            this.codeError = res.code;
          }
        })
        .finally(() => {});
    },
    refresh() {
      this.refreshPermissions();
    },
    cancel() {
      if (this.$refs.formNew) {
        this.$refs.formNew.resetValidation();
      }
      this.forms = {
        new: {
          rol: "",
        },
        detail: {
          rol: "",
        },
      };
      this.selected = null;
      this.dialogs.new = false;
      this.dialogs.detail = false;
      this.dialogs.remove = false;
    },
    dataCSV() {
      if (this.items.length == 0) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      } else {
        this.itemsCSV = this.items;
        this.success = true;
        this.msgSuccess = "Descargando documento";
      }
      this.refresh();
    },
    view(item) {
      this.forms.detail.rol = item.rol;
      this.forms.detail.roleID = item.roleID;
      this.dialogs.detail = true;
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;
        let newData = {};
        for (var key in this.forms.new) {
          if (this.forms.new[key] !== "") {
            newData[key] = this.forms.new[key];
          }
        }
        let data = {
          data: newData,
        };

        services.ws("post", "roles", data)
          .then((res) => {
            if (res.ok) {
              this.cancel();
              this.refresh();
              this.success = true;
              this.msgSuccess = "Rol creado correctamente";
            } else {
              this.error = true;
              if (res.code == "DUPLICATE_RECORD") {
                this.codeError = res.code;
              } else {
                this.codeError = res.code;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    update() {
      if (this.$refs.formDetail.validate()) {
        this.loading = true;
        this.detailData = {};
        let detailData = {};
        for (var key in this.forms.detail) {
          if (this.forms.detail[key] !== "") {
            detailData[key] = this.forms.detail[key];
          }
        }
        let data = {
          data: detailData,
        };
        services
          .ws("put", "roles", data)
          .then((res) => {
            if (res.ok) {
              this.cancel();
              this.refresh();
              this.success = true;
              this.msgSuccess = "Rol actualizado correctamente";
            } else {
              this.error = true;
              if (res.code == "DUPLICATE_RECORD") {
                this.codeError = res.code;
              } else {
                this.codeError = res.code;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    remove(item) {
      if (!this.dialogs.remove) {
        this.selected = JSON.parse(JSON.stringify(item));
        this.dialogs.remove = true;
      } else {
        this.loading = true;
        let data = {
          data: {
            roleID: parseInt(this.selected.roleID),
          },
        };
        services
          .ws("delete", "roles", data)
          .then((res) => {
            if (res.ok) {
              this.cancel();
              this.refresh();
              this.success = true;
              this.msgSuccess = "Rol elimiando correctamente";
            } else {
              this.error = true;
              this.codeError = "NO_ACTION";
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    filterResourcesChange() {
      if (this.filterResources) {
        this.textFilter = "Asignados";
        this.allPermissionsToShow = [];
        this.allPermissionsToShow = this.selectedPermissions;
      } else {
        this.textFilter = "Todos";
        this.allPermissionsToShow = this.allPermissions;
      }
    },
    closeMsg() {
      this.error = false;
    },
  },
}
</script>

<style scoped>
</style>
